// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceReportPage-cls1_2Zx","cls2":"ReferenceReportPage-cls2_5Mc ReferenceReportPage-cls1_2Zx"};